'use client';

import { RowCardLite } from '@/components/ui/data-display/cards/RowCardLite';
import { Carousel } from '@mage-ui/components';

export const MiniCardLiteItem = ({ data }) => {
  const imagePrefix = '';
  return (
    <Carousel.Slide key={data?.meta?.key}>
      <RowCardLite
        data={{
          title: data?.fields?.title,
          alt_img: data?.fields?.alt_img,
          cta_text: data?.fields?.cta_text,
          cta_slug: data?.fields?.cta_slug ?? null,
          description: data?.fields?.content,
          email: data?.fields?.email,
          placeholder: data?.fields?.placeholder,
          img_mini_card:
            data?.fields?.img_mini_card !== undefined
              ? data?.fields?.img_mini_card
                ? imagePrefix + data?.fields?.img_mini_card
                : ''
              : undefined,
        }}
      />
    </Carousel.Slide>
  );
};
